<section
  class="tabs tabs--thin tabs--in-box corporate-card-tabs tabs-with-state-tab"
>
  <div class="nav" id="nav-tab" role="tablist">
    <a
      class="nav-item nav-link"
      [ngClass]="{ active: activeTab === 1 }"
      data-toggle="tab"
      routerLinkActive="active"
      role="tab"
      (click)="setActiveTab.emit(1)"
    >
      {{ 'BATCH_MAILING.BATCHES_TAB.VIEWING_BATCH.BATCH_INFO' | translate }}
    </a>
    <a
      class="nav-item nav-link"
      [ngClass]="{ active: activeTab === 2 }"
      data-toggle="tab"
      routerLinkActive="active"
      role="tab"
      (click)="setActiveTab.emit(2)"
    >
      {{ 'BATCH_MAILING.BATCHES_TAB.VIEWING_BATCH.DEPARTURES' | translate }}
    </a>
    <a
      class="nav-item nav-link"
      [ngClass]="{ active: activeTab === 3 }"
      data-toggle="tab"
      routerLinkActive="active"
      role="tab"
      (click)="setActiveTab.emit(3)"
    >
      {{ 'BATCH_MAILING.BATCHES_TAB.VIEWING_BATCH.SENDER_DATA' | translate }}
    </a>
  </div>
  <div class="tabs__line" aria-hidden="true"></div>
</section>
